import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store/index';
import { ArrowLeftOutlined, DeleteOutlined } from '@ant-design/icons';
import { apiGetPage, apiDeleteInfo } from '../../request/api'
import { Modal, message, Spin } from 'antd'; 
import NotHaveInfo from '../nothaveinfo';

interface ManageInvoicesProps {
    handleViewChange: (newView: string, data?: any) => void;
    data?: any;
}
interface invoiceInfo {
    id: string;
    invoicePhone: string;
    invoiceBank: string;
    invoiceAddress: string;
    invoiceIdentification: string;
    invoiceHeader: string;
    bankCardNumber: string;
}

const ManageInvoices: React.FC<ManageInvoicesProps> = ({ handleViewChange, data }) => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [hoverIndex, setHoverIndex] = useState(-1); 
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [invoiceList, setInvoiceList] = useState<invoiceInfo[]>([]);
    const [deleteId, setDeleteId] = useState('');
    const [deleteString, setDeleteString] = useState('');
    const [messageApi, contextHolder] = message.useMessage();
    const [loading, setLoading] = useState(false); 

    const goBack = () => {
        handleViewChange('management');
    };

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        setLoading(true);
        apiGetPage({
            tid: '809BB53916314B70AE9F79EA842C5D42',
            page: 1,
            size: 1000,
            sort: 'status'
        }).then(res => {
            setInvoiceList(res.data.data.rows);
            setLoading(false);
        }).catch(err => {
            console.log(err);
            setLoading(false);
        });
    };

    const handleItemClick = (index: number) => {
        setSelectedIndex(index);
    };

    const goNew = () => {
        handleViewChange('addmanagement');
    };

    const handleMouseEnter = (index: number) => {
        setHoverIndex(index);
    };

    const handleMouseLeave = () => {
        setHoverIndex(-1);
    };

    const showModal = (id: string, name: string) => {
        setIsModalOpen(true);
        setDeleteId(id);
        setDeleteString(name);
    };

    const handleOk = () => {
        setIsModalOpen(false);
        setLoading(true);
        apiDeleteInfo({
            tid: '809BB53916314B70AE9F79EA842C5D42',
            did: deleteId
        }).then(res => {
            messageApi.open({
                type: 'success',
                content: '删除成功',
            });
            fetchData();
        }).catch(err => {
            console.log(err);
            setLoading(false);
        });
    };

    const handleCancel = () => {
        setIsModalOpen(false);
    };

    return (
        <Spin spinning={loading} tip=""> 
            <div className="ChooseManagement">
                {contextHolder}
                <div className='detail-back' style={{ color: themeColor }}>
                    <ArrowLeftOutlined onClick={goBack} />
                    <div className='detail-back-right' onClick={goBack}> 返回 </div>
                    <div className='detail-back-right' style={{ marginLeft: '10px' }} onClick={goNew}> 新增发票 </div>
                </div>
                <div className='management-chooselist'>
                    {invoiceList.map((item, index) => (
                        <div
                            key={index}
                            style={{ border: index === selectedIndex ? `1px solid ${themeColor}` : '1px solid #e5e5ee' }}
                            className='management-chooseitem'
                            onClick={() => handleItemClick(index)}
                        >
                            <div className='kangbuning' style={{
                                borderBottom: index === selectedIndex ? `1px solid ${themeColor}` : '1px solid #e5e5ee'
                            }}>
                                <div style={{ color: index === selectedIndex ? themeColor : 'inherit' }}>{item.invoiceHeader}</div>
                                <DeleteOutlined
                                    className="delete-icon"
                                    onMouseEnter={() => handleMouseEnter(index)}
                                    onMouseLeave={handleMouseLeave}
                                    onClick={() => showModal(item.id, item.invoiceHeader)}
                                    style={{ color: index === hoverIndex ? themeColor : 'inherit' }} // 动态设置颜色
                                />
                            </div>
                            <p style={{ marginTop: '14px' }}>纳税人识别号：{item.invoiceIdentification}</p>
                            <p>企业地址：{item.invoiceAddress}</p>
                            <p>联系电话：{item.invoicePhone}</p>
                            <p>开户行：{item.invoiceBank}</p>
                            <p style={{ paddingBottom: '14px' }}>企业账号：{item.bankCardNumber}</p>
                        </div>
                    ))}
                    {!loading && invoiceList.length === 0 && <NotHaveInfo />}
                </div>
                <Modal title="删除" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                    <p>是否删除{deleteString}</p>
                </Modal>
            </div>
        </Spin>
    );
};

export default ManageInvoices;